import React from "react";
const LandingArea = () => {
  return (
    <section className="make-world-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2 className="section__title">Platform voor en door Ouders</h2>
            </div>
          </div>
        </div>
        <div className="row world-static-wrap2">
          <div className="col-lg-12">
            <div className="world-content">
              <div className="mb-5">
                <p>
                  Opvoeden. Soms ervaren we grote blijdschap; het andere moment zitten we met de handen
                in het haar. Laat één ding je geruststellen: dit hebben we allemaal.
                </p>
                <p>
                Ouders Lokaal brengt ouders en opvoeders met elkaar in verbinding. We delen onze kennis
                en ervaringen om zo van elkaar te leren. We organiseren o.a. bijeenkomsten, diverse
                workshops en lezingen voor ouders en opvoeders en nog veel meer!
                </p>
                <p>
                  Ons doel is zoveel mogelijk ouders en opvoeders met elkaar te verbinden en nieuwe
                initiatieven te laten ontstaan. Zelf een workshop geven? Kan! Een praatgroep oprichten?
                Kan ook! Behoefte aan activiteiten voor peuters/kleuters/tieners? Laat het ons weten! Zo
                maken we opvoeden leuker en makkelijker en creëren we met elkaar een positieve
                opvoedomgeving voor onze kinderen. #oudersvoorouders.
                </p>
              </div>
              <h4 class="mb-3">
                Ontdek wat Ouders Lokaal doet in jouw gemeente:
              </h4>
              <ul>
                <li><a href="https://derondevenen.ouderslokaal.nl">De Ronde Venen</a></li>
                <li><a href="https://stichtsevecht.ouderslokaal.nl">Stichtse Vecht</a></li>
                <li><a href="https://debilt.ouderslokaal.nl/">De Bilt</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingArea;
